import angular from 'angular';
import NgBrowser from 'cars-ng-browser';
import CarsNgActiveTest from '../carsNgActiveTest';
import Config from '../config/index';
import TypModal from '../typModal/index';

import component from './postLeadSurvey.component';
import service from './postLeadSurvey.service';

export default angular.module('app.shared.postLeadSurvey', [
    NgBrowser,
    'cars.ui.angular',
    CarsNgActiveTest,
    Config,
    TypModal
])

.component('postLeadSurvey', component)
.service('postLeadSurveyService', service)

.name;
